import React, { Component } from 'react';
import { Icon } from './';
import CSSModules from 'react-css-modules';
import style from './modal.scss';

@CSSModules(style, { allowMultiple: true })
export default class Modal extends Component {
  static defaultProps = {
    size: 'medium',
    padding: true,
    showHeader: true,
    closeable: true
  };

  sizes = {
    medium: '750px',
    small: '400px'
  };

  close() {
    if (this.props.onCloseRequest) {
      this.props.onCloseRequest();
    }
  }

  wrapperClick(e) {
    if (e.target === this.refs.wrapper && this.props.closeable) {
      this.close();
    }
  }

  get content() {
    return this.props.content || this.props.children;
  }

  render() {
    const content = _.isString(this.content) ? (
      <div styleName={'content ' + (this.props.padding ? 'padding' : '')} dangerouslySetInnerHTML={{ __html: this.content }}>
      </div>
    ) : (
      <div styleName={'content ' + (this.props.padding ? 'padding' : '')}>
        {this.content}
      </div>
    );

    const header = this.props.showHeader ? (
      <div styleName="header" style={{ width: this.sizes[this.props.size] }}>
        <span styleName="title">{this.props.title}</span>
        {this.props.closeable ? (
          <a onClick={::this.close}><img src={require('$shared/images/times.svg')}/></a>
        ) : null}
      </div>
    ) : null;

    const modal = this.props.isOpen ? (
      <div className={this.props.className} styleName="root">
        <div styleName="overlay" />
        <div styleName="wrapper" ref="wrapper" onClick={::this.wrapperClick}>
          {header}
          <div styleName={'modal ' + (this.props.showHeader ? '' : 'headerless')}
            style={{ width: this.sizes[this.props.size] }}>
            <div styleName="content-wrapper">
              {content}
            </div>
          </div>
        </div>
      </div>
    ) : null;

    return modal;
  }
}



// WEBPACK FOOTER //
// ./src/components/common/modal.js